<template>
  <div style="display:flex; justify-content: center; align-items: center;width:100%" @click="ordering" class="unselect">
    <div style="text-align: center;padding-right:4px">
      <slot></slot>
    </div>
    <i v-if="!isOpen && data.ordering" class="material-icons sort-drdn-arrow-icon"
       >keyboard_arrow_down</i>
    <i v-if="isOpen && data.ordering" class="material-icons sort-drdn-arrow-icon"
       >keyboard_arrow_up</i>
  </div>
</template>

<script>
  export default {
    props:{
      data: {
        type: Object
      },
      update_field: {
        type: String
      }
    },
    // data === field
    // field: {
    //  eng_name: '', ko_name: '', width: 0, false
    // }
    data () {
      return {
        isOpen: false,
      }
    },
    watch: {
      update_field (field) {
        if(this.data.eng_name!==field) {
          this.isOpen = false;
        }
      }
    },
    methods:{
      ordering(){
        if(!this.isOpen){
          this.isOpen=true;
          this.$emit('onSelect',this.data.eng_name.replace(/\./gi, '__'));
        }
        else{
          this.isOpen=false;
          this.$emit('onSelect','-'+this.data.eng_name.replace(/\./gi, '__'));
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'

  .sort-drdn-arrow-icon
    font-size 16px
    cursor pointer
</style>
